import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { XCircle } from 'lucide-react';

export default function PaymentCancelPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center p-8">
        <XCircle className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
        <h1 className="text-2xl font-semibold mb-2" style={{ fontFamily: 'Outfit' }}>
          {t('payment.cancelledTitle')}
        </h1>
        <p className="text-muted-foreground mb-6">{t('payment.cancelledDesc')}</p>
        <button
          onClick={() => navigate(-1)}
          className="btn-primary px-6 py-2 rounded-md"
          data-testid="payment-cancel-back-btn"
        >
          {t('payment.backToReport')}
        </button>
      </div>
    </div>
  );
}
